import { render, staticRenderFns } from "./bwlists.vue?vue&type=template&id=57c22073&"
import script from "./bwlists.vue?vue&type=script&lang=js&"
export * from "./bwlists.vue?vue&type=script&lang=js&"
import style0 from "./bwlists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports